import {
  buildJoinInvitePath,
  withJoinAfterAuthIntent,
} from "@award-party/shared";

export const AUTH_FALLBACK_REDIRECT_URL = "/parties";

export function resolveAuthFallbackRedirectUrl(
  redirectUrl?: string,
): string {
  const trimmed = redirectUrl?.trim();
  if (!trimmed) {
    return AUTH_FALLBACK_REDIRECT_URL;
  }

  const isSafeInAppPath =
    trimmed.startsWith("/") && !trimmed.startsWith("//");

  return isSafeInAppPath ? trimmed : AUTH_FALLBACK_REDIRECT_URL;
}

export function getSignInHref(
  redirectUrl: string = AUTH_FALLBACK_REDIRECT_URL,
): string {
  return `/sign-in?redirect_url=${encodeURIComponent(
    resolveAuthFallbackRedirectUrl(redirectUrl),
  )}`;
}

export function getSignUpHref(
  redirectUrl: string = AUTH_FALLBACK_REDIRECT_URL,
): string {
  return `/sign-up?redirect_url=${encodeURIComponent(
    resolveAuthFallbackRedirectUrl(redirectUrl),
  )}`;
}

export function getJoinInviteSignInHref(
  inviteCode: string,
  invitedEmail?: string | null,
  invitedByUserId?: string | null,
): string {
  return getSignInHref(
    withJoinAfterAuthIntent(
      buildJoinInvitePath(inviteCode, invitedEmail, invitedByUserId),
    ),
  );
}

export function getJoinInviteSignUpHref(
  inviteCode: string,
  invitedEmail?: string | null,
  invitedByUserId?: string | null,
): string {
  return getSignUpHref(
    withJoinAfterAuthIntent(
      buildJoinInvitePath(inviteCode, invitedEmail, invitedByUserId),
    ),
  );
}
